// GENERATED FILE — DO NOT EDIT MANUALLY
// Generated from: public/config/domains/organization.registry.yml
// Run `npm run codegen` to regenerate

export enum OrganizationEvents {
  ORGANIZATION_LOADED = "organization_loaded",
  ORGANIZATIONS_LOADED = "organizations_loaded",
  ORGANIZATION_CREATED = "organization_created",
  ORGANIZATION_UPDATED = "organization_updated",
  ORGANIZATION_DELETED = "organization_deleted",
  ORGANIZATION_ERROR = "organization_error",
  ORGANIZATION_SELECTED = "organization_selected",
  ORGANIZATION_DESELECTED = "organization_deselected",
  LOAD_ORGANIZATION = "load_organization",
  LOAD_ORGANIZATIONS = "load_organizations",
  CREATE_ORGANIZATION = "create_organization",
  UPDATE_ORGANIZATION = "update_organization",
  DELETE_ORGANIZATION = "delete_organization",
  SELECT_ORGANIZATION = "select_organization",
  DESELECT_ORGANIZATION = "deselect_organization",
  REFRESH_ORGANIZATION = "refresh_organization",
  CLEAR_ORGANIZATION_ERROR = "clear_organization_error",
}

export enum OrganizationEndpoints {
  LIST_ORGANIZATIONS = "/api/v1/organizations",
  GET_ORGANIZATION = "/api/v1/organizations/:id",
  CREATE_ORGANIZATION = "/api/v1/organizations",
  UPDATE_ORGANIZATION = "/api/v1/organizations/:id",
  DELETE_ORGANIZATION = "/api/v1/organizations/:id",
  GET_ORGANIZATION_SUMMARY = "/api/v1/organizations/:id/summary",
  GET_TAG_SCHEMA = "/api/v1/organizations/:alias/tag-schema",
  CREATE_TAG_SCHEMA = "/api/v1/organizations/:alias/tag-schema",
  UPDATE_TAG_SCHEMA = "/api/v1/organizations/:alias/tag-schema/:id",
  DELETE_TAG_SCHEMA = "/api/v1/organizations/:alias/tag-schema/:id",
  LIST_DEPARTMENTS = "/api/v1/organizations/:alias/departments",
  CREATE_DEPARTMENT = "/api/v1/organizations/:alias/departments",
  DELETE_DEPARTMENT = "/api/v1/organizations/:alias/departments/:id",
  LIST_TEAMS = "/api/v1/organizations/:alias/teams",
  CREATE_TEAM = "/api/v1/organizations/:alias/teams",
  UPDATE_TEAM = "/api/v1/organizations/:alias/teams/:id",
  DELETE_TEAM = "/api/v1/organizations/:alias/teams/:id",
}
